import {
  useGetPdfDesignLayersQuery,
  useGetProjectMapServerLayersQuery,
} from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { PDFDesignLayersContext } from './types'
import { useCallback } from 'react'
import { PDFDesignLayerType } from '../types'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } = createStrictContext<PDFDesignLayersContext>(
  'PDFDesignLayersContext'
)

export const usePDFDesignLayersContext = useContextFn

const PDFDesignLayersProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const projectLayers = useGetProjectMapServerLayersQuery({
    ...DefaultQueryHookOptions,
    variables: { globalId: projectId },
  })
  const pdfDesignLayers = useGetPdfDesignLayersQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })

  // i tried moving all this out of a context and into the TabContent component
  // the form stopped working... so context it is...
  return (
    <Provider
      value={{
        projectLayers,
        pdfDesignLayers: {
          ...pdfDesignLayers,
          getSettings: useCallback(
            (typename) => {
              const found = pdfDesignLayers.data?.pdfDesignLayers.records.find(
                ({ index }) =>
                  index === PDFDesignLayerType[typename].featureServerId
              )
              return found?.settings ?? null
            },
            [pdfDesignLayers.data?.pdfDesignLayers.records]
          ),
        },
      }}
    >
      {children}
    </Provider>
  )
}

export default PDFDesignLayersProvider
